
export interface AuthPaths {
  SignIn: string,
  Error404: string,
}

export const authPaths: AuthPaths = {
  Error404: 'error-404',
  SignIn: 'signin'
}